import { HiiService, ServiceTile } from '../service-tile/ServiceTile';
import React from 'react';
import { ServicesList } from '../ServiceGrid.styles';
import { Accordion } from '../../Accordion/Accordion';
import { Typography } from '@hiiretail/synergy-ui';
import styled from 'styled-components';


type ServiceCategoryProps = {
  category: string;
  items: Array<HiiService>;
  index: number;
  isExpanded?: boolean;
  onToggle?: (isOpen: boolean) => void;
};

type ServiceCategoryComponent = React.FC<ServiceCategoryProps>;


const StyledTypography = styled(Typography)`
  margin: 0 ${({ theme }) => theme.spacing(2)}px 0 0;
`

export const ServiceCategory: ServiceCategoryComponent = ({ category, items, index, isExpanded, onToggle }) => (
  <Accordion
    title={<StyledTypography variant="header2">{category}</StyledTypography>}
    isExpanded={isExpanded !== undefined ? isExpanded : index === 0 || index === 1}
    onToggle={onToggle}
  >
    <ServicesList>
      {items.map((service, index) => (
        <ServiceTile
          data-testid={service.route}
          service={service}
          index={index}
          key={service.route}
        />
      ))}
    </ServicesList>
  </Accordion>




  // <Accordion defaultExpanded={index === 0 || index === 1}>
  //   <AccordionSummary expandIcon={<ExpandMoreIcon />}>
  //     <Typography variant="header2">{category}</Typography>
  //   </AccordionSummary>
  //   <AccordionDetails>
  //     <ServicesList>
  //       {items.map((service, index) => (
  //         <ServiceTile
  //           data-testid={service.route}
  //           service={service}
  //           index={index}
  //           key={service.route}
  //         />
  //       ))}
  //     </ServicesList>
  //   </AccordionDetails>
  // </Accordion>
);
